import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import { PropTypes } from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
import DynamicForm from './DynamicForm';
import { SubmitButton } from '../../UI';
import * as Yup from 'yup';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';

const useStyles = makeStyles({
    submitBtnContainer: {
        paddingTop: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px',
        alignItems: 'center',
        flexFlow: 'row-reverse'
    },
    sectionDivider: {
        borderColor: '#ffffff73',
        margin: '20px 0 10px'
    },
    emptyFieldTip: {
        fontWeight: 'bold',
        padding: '0 10px'
    }
});
export default function MedicalHistoryForm(props) {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = useStyles();
    const renderEmptyHint = (values) => {
        const listLength = props.sections[0].fields?.length;
        const valuesLength = Object.values(values).filter((val) => val && val.length)?.length;
        const diff = listLength - valuesLength;

        if (diff) {
            return <div className={classes.emptyFieldTip}>{getAlert(listLength, diff)}</div>;
        } else {
            return null;
        }
    };
    const getAlert = (listLength, diff) => {
        if (diff === 1) {
            if (lang === 'fa') {
                return `One of ${listLength} fields is still empty`;
            } else {
                return ' یکی از ' + listLength + ' فیلد همچنان خالی است.';
            }
        } else {
            if (lang === 'fa') {
                return diff + ' ' + ' فیلد از ' + listLength + ' تا همچنان خالی است.';
            } else {
                return `${diff} number of ${listLength} fields are still empty`;
            }
        }
    };
    return (
        <Formik
            enableReinitialize
            initialValues={props.values}
            onSubmit={async (values, { setSubmitting }) => {
                await props.submit(values);
                setSubmitting(false);
            }}
            validationSchema={Yup.object(props.validation)}
            component={({ isSubmitting, values }) => (
                <Form>
                    {props.sections &&
                        props.sections.length &&
                        [...props.sections]
                            .sort((a, b) => +a.order - +b.order)
                            .map((section, index) => (
                                <div key={index}>
                                    {index > 0 && <hr className={classes.sectionDivider} />}
                                    {/* <div>{section.title}</div> */}
                                    <Grid container spacing={0} key={section.title}>
                                        {section?.fields && section.fields.length && (
                                            <>
                                                {[...section.fields]
                                                    .sort((a, b) => +a.order - +b.order)
                                                    .map((form, index) => (
                                                        <Grid key={index} item md={12} xs={12}>
                                                            <DynamicForm
                                                                type={form.type}
                                                                name={form.name}
                                                                label={form.label}
                                                                choices={form.choices}
                                                            />
                                                        </Grid>
                                                    ))}

                                                {/* {section.fields
                                            .filter((form) => form.type === 'textarea')
                                            .map((form, index) => (
                                                <Grid key={index} item md={12} xs={12}>
                                                    <DynamicForm
                                                        type={form.type}
                                                        name={form.name}
                                                        label={form.label}
                                                    />
                                                </Grid>
                                            ))} */}
                                            </>
                                        )}
                                    </Grid>
                                </div>
                            ))}

                    <div className={classes.submitBtnContainer}>
                        <SubmitButton
                            isSubmitting={isSubmitting}
                            submitText={props.formId ? messages.edit : messages.submit}
                        />
                        {renderEmptyHint(values)}
                    </div>
                </Form>
            )}
        />
    );
}
MedicalHistoryForm.propTypes = {
    formId: PropTypes.number,
    match: PropTypes.object,
    sections: PropTypes.array,
    values: PropTypes.object,
    submit: PropTypes.func,
    validation: PropTypes.object
};
